<template>
  <div v-if="launchDate" class="mb-12">
    <h3 class="text-lg font-semibold mb-4" :class="titleClass">เปิดตัวในอีก</h3>
    <div class="grid grid-cols-4 gap-4 max-w-md mx-auto">
      <div v-for="(unit, key) in countdown" :key="key" class="bg-white rounded-lg shadow-md p-4">
        <div class="text-2xl font-bold" :class="numberClass">{{ unit.value }}</div>
        <div class="text-sm" :class="labelClass">{{ unit.label }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  launchDate: {
    type: Date,
    required: true
  },
  color: {
    type: String,
    default: 'green'
  }
})

// Countdown timer
const countdown = ref({
  days: { value: 0, label: 'วัน' },
  hours: { value: 0, label: 'ชั่วโมง' },
  minutes: { value: 0, label: 'นาที' },
  seconds: { value: 0, label: 'วินาที' }
})

// Color classes based on color prop
const titleClass = computed(() => {
  const colorMap = {
    green: 'text-gray-900',
    amber: 'text-amber-900',
    blue: 'text-blue-900',
    orange: 'text-orange-900',
    emerald: 'text-emerald-900',
    purple: 'text-purple-900'
  }
  return colorMap[props.color] || 'text-gray-900'
})

const numberClass = computed(() => {
  const colorMap = {
    green: 'text-green-600',
    amber: 'text-amber-600',
    blue: 'text-blue-600',
    orange: 'text-orange-600',
    emerald: 'text-emerald-600',
    purple: 'text-purple-600'
  }
  return colorMap[props.color] || 'text-green-600'
})

const labelClass = computed(() => {
  const colorMap = {
    green: 'text-gray-600',
    amber: 'text-amber-600',
    blue: 'text-blue-600',
    orange: 'text-orange-600',
    emerald: 'text-emerald-600',
    purple: 'text-purple-600'
  }
  return colorMap[props.color] || 'text-gray-600'
})

// Countdown calculation
const updateCountdown = () => {
  if (!props.launchDate) return
  
  const now = new Date().getTime()
  const launch = new Date(props.launchDate).getTime()
  const distance = launch - now
  
  if (distance > 0) {
    countdown.value.days.value = Math.floor(distance / (1000 * 60 * 60 * 24))
    countdown.value.hours.value = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    countdown.value.minutes.value = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    countdown.value.seconds.value = Math.floor((distance % (1000 * 60)) / 1000)
  }
}

// Setup countdown timer
let countdownInterval
onMounted(() => {
  updateCountdown()
  countdownInterval = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval)
  }
})
</script>